import { controls } from "../../controls";

const rp551 = {
  label: "Branchwise KYC",
  pageLabel: "Branchwise KYC Report",
  starting: true,
  url: "rp551",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Product Code", width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),


    ...controls.displayText({ tab: "filter", label: "Last Transaction Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "last_trn_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Branchwise KYC Report",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "domain_code",
        width: 80,
        rwidth: "*"

      },
      {
        Header: "Branch Name",
        accessor: "domain_name",
        width: 150,
        rwidth: 100
      },
      {
        accessor: "Total_Acs",
        Header: "Total Accounts",
        rwidth: "*"
      },

      {
        Header: "Operative Accounts",
        columns: [
          {
            Header: "KYC Compliant",
            accessor: "Operative_KYC_Compliant",
            rwidth: "*"
          },
          {
            Header: "KYC Non Compliant",
            accessor: "Operative_KYC_Non_Compliant",
            rwidth: "*"
          },
          {
            accessor: "totaloperative",
            Header: "Total",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'Operative_KYC_Compliant' }, { source: 'row', field: 'Operative_KYC_Non_Compliant' },
              ], resultVar: 'total'
            }],
            rwidth: "*"
          }
        ]
      },
      {
        Header: "Inoperative Accounts",
        columns: [
          {
            Header: "KYC Compliant",
            accessor: "Inoperative_KYC_Compliant",
            rwidth: "*"
          },
          {
            Header: "KYC Non Compliant",
            accessor: "Inoperative_KYC_Non_Compliant",
            rwidth: "*"
          },
          {
            accessor: "totalin",
            Header: "Total",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'Inoperative_KYC_Compliant' },
              { source: 'row', field: 'Inoperative_KYC_Non_Compliant' },
              ], resultVar: 'total'
            }],
            rwidth: "*"
          }
        ]
      },
      {
        Header: "Summary of KYC Compliance",
        columns: [
          {
            accessor: "kyccompliantsummary",
            Header: "KYC Compliant",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'Operative_KYC_Compliant' }, { source: 'row', field: 'Inoperative_KYC_Compliant' },
              ], resultVar: 'total'
            }],
            rwidth: "*"
          },
          {
            accessor: "kycnoncompliantsummary",
            Header: "KYC Non Compliant",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'Operative_KYC_Non_Compliant' },
              { source: 'row', field: 'Inoperative_KYC_Non_Compliant' },
              ], resultVar: 'total'
            }],
            rwidth: "*"
          },
        ]
      },
      {
        Header: "No. of Accounts Frozen",
        accessor: "kycnoncompliantsummary_frozen",
        formula: [{
          f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'Operative_KYC_Non_Compliant' },
          { source: 'row', field: 'Inoperative_KYC_Non_Compliant' },
          ], resultVar: 'total'
        }],
        rwidth: "*"
      }
    ]
  }
};

export default rp551;